// extracted by mini-css-extract-plugin
module.exports = {"Screenshots":"screenshots-module--Screenshots--2Gss5"};